import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { TrendingUp } from "lucide-react";
import NavbarEnlaces from "../../../layout/NavbarEnlaces";
import Modal from "../../../layout/Modal/Modal";
import ListBadge from "../../../layout/ListBadge";
import { dataResultadosE2021 } from "../../../data/dataProcesosElectorales";
import "./ProcesosElectorales.css";

// Ícono de Boleta / Urna Electoral con degradado institucional
const BallotBoxIcon = ({
  size = 64,
  fill = "url(#enlacesGradient)",
  stroke = "url(#enlacesGradient)",
  className = "",
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    style={{ overflow: "visible" }}
    {...props}
  >
    {/* 1. Hoja / Boleta de votación entrando por la ranura superior */}
    <rect
      x="7"
      y="2"
      width="10"
      height="9"
      rx="1.5"
      fill="#ffffff"
      stroke={fill}
      strokeWidth="1.8"
    />

    {/* 2. Marca de voto (Checkmark) nítida en la boleta */}
    <path
      d="m9.5 6.2 1.6 1.6 3.4-3.4"
      stroke={fill}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />

    {/* 3. Urna electoral sólida con relleno del degradado institucional */}
    <path
      d="M3.5 10c0-.83.67-1.5 1.5-1.5h14c.83 0 1.5.67 1.5 1.5v9.5H3.5V10Z"
      fill={fill}
      stroke={stroke}
      strokeWidth="1.2"
      strokeLinejoin="round"
    />

    {/* 4. Ranura superior de inserción en blanco para separación visual */}
    <path
      d="M6.5 10h11"
      stroke="#ffffff"
      strokeWidth="1.6"
      strokeLinecap="round"
    />

    {/* 5. Base inferior horizontal de la urna */}
    <path
      d="M2 20.5h20"
      stroke={fill}
      strokeWidth={2.2}
      strokeLinecap="round"
    />
  </svg>
);

const ProcesosElectorales = () => {
  useEffect(() => {
    document.title = `Procesos Electorales`;
  }, []);
  return (
    <>
      {/* Definición del gradiente SVG institucional */}
      <svg
        width="0"
        height="0"
        style={{ position: "absolute", pointerEvents: "none" }}
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="enlacesGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#A90786" />
            <stop offset="100%" stopColor="#5A2C6E" />
          </linearGradient>
          <linearGradient id="enlacesGradientCanvas" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="24" y2="24">
            <stop offset="0%" stopColor="#A90786" />
            <stop offset="100%" stopColor="#5A2C6E" />
          </linearGradient>
        </defs>
      </svg>
      <NavbarEnlaces title="Resultados Electorales" />
      <div className="margin-bottom-1"> 
        <div className="Content__grid">
          <div>
            <Link to="/HistorialPE" className="ResultadosElectorales__link">
              <TrendingUp
                size={64}
                stroke="url(#enlacesGradient)"
                strokeWidth={2.4}
                className="ResultadosElectorales__icon"
              />
            </Link>
            <p className="mt-2">Historial de Resultados (1995 - 2013)</p>
          </div>
          <div>
            <Link to="/PE20152016" className="ResultadosElectorales__link">
              <BallotBoxIcon
                fill="url(#enlacesGradient)"
                size={64}
                className="ResultadosElectorales__icon"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2015 - 2016</p>
          </div>
          <div>
            <Link to="/PEE2017" className="ResultadosElectorales__link">
              <BallotBoxIcon
                fill="url(#enlacesGradient)"
                size={64}
                className="ResultadosElectorales__icon"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2017</p>
          </div>
          <div>
            <Link to="/PE2018" className="ResultadosElectorales__link">
              <BallotBoxIcon
                fill="url(#enlacesGradient)"
                size={64}
                className="ResultadosElectorales__icon"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2017 - 2018</p>
          </div>
          <div>
            <Link to="/PE20202021" className="ResultadosElectorales__link">
              <BallotBoxIcon
                fill="url(#enlacesGradient)"
                size={64}
                className="ResultadosElectorales__icon"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2020 - 2021</p>
          </div>
          <div>
            <a
              href="/#"
              className="ResultadosElectorales__link"
              rel="noreferrer"
              data-bs-toggle="modal"
              data-bs-target="#PresidenciasComunidad2021"
            >
              <BallotBoxIcon
                fill="url(#enlacesGradient)"
                size={64}
                className="ResultadosElectorales__icon"
              />
            </a>
            <p className="mt-2">Proceso Electoral Extraordinario 2021</p>
          </div>
          <div>
            <Link to="/PE20232024" className="ResultadosElectorales__link">
              <BallotBoxIcon
                fill="url(#enlacesGradient)"
                size={64}
                className="ResultadosElectorales__icon"
              />
            </Link>
            <p className="mt-2">Proceso Electoral 2023 - 2024 <br></br>Proceso Electoral Extraordinario 2024</p>
          </div>
        </div>
      </div>

      {/* ELECCION JUDICIAL */}

      <div className="margin-bottom-1 mt-5">
        <div className="Enlances__title mb-4">Resultados Electorales Judiciales</div>
        <div className="Content__grid">
          <div>
            <Link to="/PEPJ20242025" className="ResultadosElectorales__link">
              <BallotBoxIcon
                fill="url(#enlacesGradient)"
                size={64}
                className="ResultadosElectorales__icon"
              />
            </Link>
            <p className="mt-2">Proceso Electoral Extraordinario para el Poder Judicial Local 2024-2025</p>
          </div>
        </div>
      </div>
      {/* Modal */}
      <Modal
      idModal="PresidenciasComunidad2021"
      titleModal="Resultados Electorales Presidencias de Comunidad 2021"
      sizeModal=""
      contentModal={
        <ListBadge ifNumbered={""} listsBadgeItem={dataResultadosE2021} />
      }
      />
    </>
  );
};
export default ProcesosElectorales;
